import { useEffect } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthProvider';

import { AUTH_ROUTES } from '@/config/routes';

export const PrivateRoute = (props: RouteProps) => {
  const auth = useAuth();
  const { location } = props;

  useEffect(() => {
    if (!auth.authenticated || !auth.profileComplete) {
      sessionStorage.setItem('hf:intendedPath', location?.pathname || '');
    }
  }, [auth, location]);

  if (!auth.authenticated) {
    return <Redirect to={AUTH_ROUTES.signIn} />;
  }

  if (!auth.profileComplete) {
    return <Redirect to={AUTH_ROUTES.profile} />;
  }

  return <Route {...props} />;
};
